import { render, staticRenderFns } from "./reviewItem.vue?vue&type=template&id=68d554d3&scoped=true&"
import script from "./reviewItem.vue?vue&type=script&lang=js&"
export * from "./reviewItem.vue?vue&type=script&lang=js&"
import style0 from "./reviewItem.vue?vue&type=style&index=0&id=68d554d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d554d3",
  null
  
)

export default component.exports